import { useCallback, useEffect, useState } from 'react';
import { Typography } from '../../Typography';

type Props = {
  lastSavedAt: Date | null;
};

export default function AutosaveIndicator({ lastSavedAt }: Props) {
  const [displayText, setDisplayText] = useState<string | null>(null);

  const updateText = useCallback(() => {
    if (!lastSavedAt && !displayText) return;
    if (!lastSavedAt) return setDisplayText(null);

    const secondsAgo = Math.floor((Date.now() - lastSavedAt.getTime()) / 1000);
    const minutesAgo = Math.floor(secondsAgo / 60);

    const text =
      minutesAgo >= 60
        ? `Autosaved ${Math.floor(minutesAgo / 60)} hr ago`
        : minutesAgo > 0
          ? `Autosaved ${minutesAgo} min ago`
          : `Autosaved ${secondsAgo} sec ago`;

    setDisplayText(text);
  }, [lastSavedAt]);

  useEffect(() => {
    updateText();

    const interval = setInterval(updateText, 30000);
    return () => clearInterval(interval);
  }, [updateText, lastSavedAt]);

  if (!displayText) return null;

  return (
    <Typography variant='label' color='grey'>
      {displayText}
    </Typography>
  );
}
